export default __webpack_public_path__ + "static/media/fpb11000.4fe5b894.png";